export const defaultSelect = {
  value: '',
  label: '',
};
